export default function Calendar() {
  // Handle Events Manager calendar "more..." link clicks to trigger modal
  // Use event delegation to catch dynamically added elements (including AJAX-loaded content)
  function modifyMoreLinks() {
    // Find all "more..." links in calendars and modify them
    document.querySelectorAll('.em-calendar .em-cal-day-limit a').forEach(function(link) {
      if (!link.classList.contains('em-modified')) {
        // Mark as modified to avoid duplicate processing
        link.classList.add('em-modified');

        // Extract date from the URL or find the parent day
        const dayContainer = link.closest('.em-cal-day');
        if (dayContainer) {
          const dayDateElement = dayContainer.querySelector('.em-cal-day-date');
          if (dayDateElement) {
            const calendarDate = dayDateElement.getAttribute('data-calendar-date');
            if (calendarDate) {
              // Add our custom data attribute
              link.setAttribute('data-calendar-date', calendarDate);
              link.classList.add('em-cal-day-more-trigger');
            }
          }
        }
      }
    });

    // Fix .eventful-today links to use modal behavior
    document.querySelectorAll('.em-calendar .eventful-today a').forEach(function(link) {
      if (!link.classList.contains('em-today-modified')) {
        // Mark as modified to avoid duplicate processing
        link.classList.add('em-today-modified');

        // Extract date from the URL or find the parent day
        const dayContainer = link.closest('.em-cal-day');
        if (dayContainer) {
          const dayDateElement = dayContainer.querySelector('.em-cal-day-date');
          if (dayDateElement) {
            const calendarDate = dayDateElement.getAttribute('data-calendar-date');
            if (calendarDate) {
              // Add our custom data attribute and trigger class
              link.setAttribute('data-calendar-date', calendarDate);
              link.classList.add('em-cal-day-today-trigger');
            }
          }
        }
      }
    });

    // Also ensure calendars have the responsive-dateclick-modal class for day clicks to work
    document.querySelectorAll('.em-calendar').forEach(function(calendar) {
      if (!calendar.classList.contains('responsive-dateclick-modal')) {
        calendar.classList.add('responsive-dateclick-modal');
      }
    });
  }

  // Function to hide events beyond the 5th in calendar view and force more buttons
  function hideExcessCalendarEvents() {
    document.querySelectorAll('.em-cal-day').forEach(function(day) {
      const events = day.querySelectorAll('.em-cal-event');
      const eventCount = events.length;

      // Hide events beyond the 5th
      events.forEach(function(event, index) {
        if (index >= 5) {
          event.classList.add('hidden');
        }
      });

      // Force create "more" button if there are more than 5 events and no existing limit button
      if (eventCount > 5 && !day.querySelector('.em-cal-day-limit')) {
        const hiddenCount = eventCount - 5;
        const moreButton = document.createElement('div');
        moreButton.className = 'em-cal-day-limit';

        // Get the day's date for the link
        const dayDateElement = day.querySelector('.em-cal-day-date');
        let link = '#';
        if (dayDateElement) {
          const calendarDate = dayDateElement.getAttribute('data-calendar-date');
          if (calendarDate) {
            // Create a basic link format - this might need adjustment based on your setup
            link = '?cal_day=' + calendarDate;
          }
        }

        moreButton.innerHTML = '<a href="' + link + '" class="button">' + hiddenCount + ' more...</a>';

        // Add the more button to the day
        day.appendChild(moreButton);

        // Immediately process the new button for modal functionality
        const newLink = moreButton.querySelector('a');
        if (newLink && dayDateElement) {
          const calendarDate = dayDateElement.getAttribute('data-calendar-date');
          if (calendarDate) {
            newLink.setAttribute('data-calendar-date', calendarDate);
            newLink.classList.add('em-cal-day-more-trigger', 'em-modified');
          }
        }
      }
    });
  }

  // Run initially
  hideExcessCalendarEvents();
  modifyMoreLinks();

  // Run after AJAX calls (Events Manager uses jQuery for AJAX)
  if (typeof jQuery !== 'undefined') {
    jQuery(document).ajaxComplete(function() {
      setTimeout(modifyMoreLinks, 100); // Small delay to ensure DOM is updated
    });

    // Listen for Events Manager calendar loaded events (for AJAX navigation)
    jQuery(document).on('em_calendar_loaded', function(event, calendar) {
      // Small delay to ensure DOM is fully updated
      setTimeout(function() {
        hideExcessCalendarEvents();
        modifyMoreLinks();
      }, 50);
    });
  }

  // Also run periodically to catch any missed elements
  setInterval(modifyMoreLinks, 2000);

  // Handle clicks on "more" and "today" triggers
  document.addEventListener('click', function(e) {
    // Check if the clicked element or any of its parents has the trigger classes
    const trigger = e.target.closest('.em-cal-day-more-trigger, .em-cal-day-today-trigger');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();

      const calendarDate = trigger.getAttribute('data-calendar-date');
      const calendar = trigger.closest('.em-calendar');

      if (calendar && calendarDate) {
        // Find the modal content for this date
        const modal = calendar.querySelector('.em-cal-date-content[data-calendar-date="' + calendarDate + '"]');

        if (modal) {
          // Set the calendar ID attribute for the modal
          modal.setAttribute('data-calendar-id', calendar.getAttribute('id'));

          // Trigger the same modal opening function that Events Manager uses
          if (typeof openModal === 'function') {
            openModal(jQuery(modal));
          } else {
            // Fallback: try to find and click the day number link to trigger the modal
            const dayLink = calendar.querySelector('.em-cal-day-date[data-calendar-date="' + calendarDate + '"]');
            if (dayLink) {
              dayLink.click();
            }
          }
        }
      }
    }
  });
}
